import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    DateTimeColumn,
  } = columns(data);

  return [
    {
      Header: 'History',
      columns: [
        new TextColumn('From Operator', 'operatorFrom'),
        new TextColumn('From IMPC', 'impcFrom'),
        new TextColumn('To Operator', 'operatorTo'),
        new TextColumn('To IMPC', 'impcTo'),
        new NonZeroNumberColumn('Quantity', 'quantity'),
        new NonZeroNumberColumn('Objected Quantity', 'quantityObjected'),
        new NonZeroNumberColumn('Confirmed Quantity', 'quantityConfirmed'),
        new DateTimeColumn('Departure Date and time', 'departureDateTime'),
        new DateTimeColumn('Arrival Date and time', 'arrivalDateTime'),
        new TextColumn('User', 'lastUpdateUser'),
        new DateTimeColumn('Last action occurrence', 'lastUpdateDate'),
        new TextColumn('Comments', 'comments'),
        new TextColumn('Status', 'status'),
      ],
    },
  ];
};
